import React from 'react'
import TitleBar from '../TitleBar/TitleBar'
import './Header.css'

const Header = () => {
  return (
    <div>
        <TitleBar/>
    </div>
  )
}

export default Header